import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {Observable} from 'rxjs';
import {ContentService} from './services/content.service';
import {DataService} from './services/data.service';
import {WorkspaceService} from './services/workspace.service';

export class AlfrescoAuthorizationHttpHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO: use a better way to fetch the token
    const token = localStorage.getItem('token');
    if (token) {
      const clonedRequest = req.clone({headers: req.headers.set('Alfresco-Authorization', token)});
      return next.handle(clonedRequest);
    }
    return next.handle(req);
  }
}

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AlfrescoAuthorizationHttpHeaderInterceptor,
    multi: true,
  }],
})
export class V2NodeApiModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: V2NodeApiModule,
      providers: [
        ContentService,
        DataService,
        WorkspaceService,
      ]
    };
  }
}
